import { T } from "components/util/t";
import { getOptionsPriceRange } from "../paidRegistrationUtils";
import { Event } from "graphql/generated/types";

type PriceDescriptionsProps = {
    isSeriesRegistration?: boolean;
    totalDivisions?: number;
} & Pick<Event, "registrationOptions" | "paymentOptions">;

export const PriceDescriptions: React.FC<PriceDescriptionsProps> = ({
    registrationOptions,
    isSeriesRegistration,
    paymentOptions,
    totalDivisions,
}) => {
    const priceRange =
        paymentOptions && getOptionsPriceRange(paymentOptions, totalDivisions);
    const extraDivisionPrice = paymentOptions?.extraDivisionPrice;
    const familyTotal = paymentOptions?.familyTotal;
    const currency = paymentOptions?.currency;
    const noEntryFees =
        priceRange?.length === 0 ||
        (priceRange?.length === 1 && priceRange?.[0] === 0);

    return (
        <>
            {registrationOptions?.divisionLimit && (
                <T max={registrationOptions.divisionLimit}>
                    {isSeriesRegistration
                        ? "max_membership_options_per_athlete"
                        : "max_divisions_per_athlete"}
                </T>
            )}
            {priceRange &&
                (noEntryFees ? (
                    "No entry fees"
                ) : priceRange.length === 1 && extraDivisionPrice == null ? (
                    <T price={priceRange[0]} currency={currency}>
                        {isSeriesRegistration
                            ? "single_membership_option_price"
                            : "single_division_price"}
                    </T>
                ) : priceRange.length === 1 && extraDivisionPrice != null ? (
                    <T
                        price={priceRange[0]}
                        extra={extraDivisionPrice}
                        currency={currency}
                    >
                        {isSeriesRegistration
                            ? "single_membership_option_price_with_extra"
                            : "single_division_price_with_extra"}
                    </T>
                ) : extraDivisionPrice == null ? (
                    <T
                        min={priceRange[0]}
                        max={priceRange[1]}
                        currency={currency}
                    >
                        {isSeriesRegistration
                            ? "membership_option_price_range"
                            : "division_price_range"}
                    </T>
                ) : (
                    <T
                        min={priceRange[0]}
                        max={priceRange[1]}
                        extra={extraDivisionPrice}
                        currency={currency}
                    >
                        {isSeriesRegistration
                            ? "membership_option_price_range_with_extra"
                            : "division_price_range_with_extra"}
                    </T>
                ))}
            {!noEntryFees &&
                familyTotal &&
                Object.keys(familyTotal).length > 0 &&
                (isSeriesRegistration ? (
                    <T
                        familyDiscounts={Object.entries(familyTotal)}
                        currency={currency}
                    >
                        family_discounts_for
                    </T>
                ) : (
                    <T
                        groupDiscounts={Object.entries(familyTotal)}
                        currency={currency}
                    >
                        group_discounts_for
                    </T>
                ))}
        </>
    );
};
